var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrialShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 5.1875C21.6973 5.1875 23 6.49023 23 8.0625V19.5625C23 21.1797 21.6973 22.4375 20.125 22.4375H2.875C1.25781 22.4375 0 21.1797 0 19.5625V8.0625C0 6.49023 1.25781 5.1875 2.875 5.1875H5.75V3.03125C5.75 1.86328 6.69336 0.875 7.90625 0.875H15.0938C16.2617 0.875 17.25 1.86328 17.25 3.03125V5.1875H20.125ZM7.1875 3.03125V5.1875H15.8125V3.03125C15.8125 2.67188 15.4531 2.3125 15.0938 2.3125H7.90625C7.50195 2.3125 7.1875 2.67188 7.1875 3.03125ZM21.5625 19.5625V13.8125H15.0938V16.6875C15.0938 17.0918 14.7344 17.4062 14.375 17.4062H8.625C8.2207 17.4062 7.90625 17.0918 7.90625 16.6875V13.8125H1.4375V19.5625C1.4375 20.3711 2.06641 21 2.875 21H20.125C20.8887 21 21.5625 20.3711 21.5625 19.5625ZM9.34375 15.9688H13.6562V13.8125H9.34375V15.9688ZM21.5625 12.375V8.0625C21.5625 7.29883 20.8887 6.625 20.125 6.625H2.875C2.06641 6.625 1.4375 7.29883 1.4375 8.0625V12.375H21.5625Z",
    fill: "#009E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrialShift);
export default __webpack_public_path__ + "static/media/trial-shift.7002133edfbc0686c4ff219b78f650c7.svg";
export { ForwardRef as ReactComponent };